import styled from "@emotion/styled";

/**
 * @deprecated This component is being removed in V6+, February 2025, in favor of the `SelectV2/MultiSelectV2` components.
 */
// See https://github.com/philipwalton/flexbugs#flexbug-3
export const IE11Flexbug3Fix = styled("div")`
    display: flex;
    flex-direction: column;
`;
//# sourceMappingURL=IE11Flexbug3Fix.js.map